import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import CustomerDetailsFilledForm from "./filled";
import CustomerDetailsUnfilledForm from "./unfilled";
// import CustomerEligibility from "../eligibilty";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  FormGroup,
  Typography,
} from "@mui/material";
import { isCustomerDetailsProceedButtonDisabled } from "../../../helpers/validation";
import { BUTTON_PROCEED } from "../../../constants";

function CustomerDetailsForm({
  classes: { containerButton, formGroup },
  accordian,
  backdrop,
  capturePan,
  errorMessage,
  errors,
  form,
  isFormSubmitted,
  handleAccordianClick,
  handleChange,
  handleChangeChipSelect,
  handleClose,
  handleCheckboxChange,
  handleClick,
  modal,
  panDetails,
  panErrorMessage = "",
  isPanVerifiedError = false,
  onSubmit,
  orderDetails,
  cities,
  states,
  selectedCityOption,
  setSelectedCityOption,
  selectedStateOption,
  setSelectedStateOption,
  validateInputLength,
  verifyPancardDetails,
}) {
  return (
    <form noValidate autoComplete="off" onSubmit={onSubmit}>
      <Box direction="column">
        <CustomerDetailsFilledForm
          accordian={accordian}
          form={form}
          errorMessage={errorMessage}
          handleAccordianClick={handleAccordianClick}
          handleChange={handleChange}
          handleChangeChipSelect={handleChangeChipSelect}
          validateInputLength={validateInputLength}
        />

        <CustomerDetailsUnfilledForm
          accordian={accordian}
          capturePan={capturePan}
          form={form}
          errorMessage={errorMessage}
          isFormSubmitted={isFormSubmitted}
          handleAccordianClick={handleAccordianClick}
          handleChange={handleChange}
          handleCheckboxChange={handleCheckboxChange}
          cities={cities}
          panErrorMessage={panErrorMessage}
          isPanVerifiedError={isPanVerifiedError}
          states={states}
          selectedCityOption={selectedCityOption}
          setSelectedCityOption={setSelectedCityOption}
          selectedStateOption={selectedStateOption}
          setSelectedStateOption={setSelectedStateOption}
          validateInputLength={validateInputLength}
          verifyPancardDetails={verifyPancardDetails}
          orderDetails={orderDetails}
        />
      </Box>

      <ErrorMessage errors={errors} modal={modal} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        <CallToAction
          buttonType={"submit"}
          errorMessage={errorMessage}
          form={form}
          isDisabled={isCustomerDetailsProceedButtonDisabled(
            isFormSubmitted,
            form,
            errorMessage,
            selectedCityOption,
            selectedStateOption,
            capturePan
          )}
          isFormSubmitted={isFormSubmitted}
          text={BUTTON_PROCEED}
          handleClick={() => {}}
        />
      </Box>

      {modal.snackbar && (
        <NotificationMessage
          open={modal.snackbar}
          message={
            "The OTP has been sent to your Aadhaar-linked mobile number."
          }
          onClose={() => handleClose("snackbar", false)}
        />
      )}

      {modal.panMismatch && (
        <Dialog
          aria-labelledby="simple-dialog-title"
          fullScreen={true}
          fullWidth={true}
          onClose={() => handleClose("panMismatch", false)}
          open={modal.panMismatch}
          maxWidth={"lg"}
        >
          <DialogTitle id="simple-dialog-title">
            <Box display="flex" justifyContent="center">
              <SectionTitle
                backButton={false}
                // onClickHandler={handleBack}
                title={"Details Mismatch"}
              />
            </Box>
          </DialogTitle>

          <Box>
            <Box m={1} pt={0} pb={0}>
              <Box className={formGroup}>
                <Typography variant="body2">PAN: {panDetails?.pan}</Typography>
              </Box>
              <Box>
                <Box className={formGroup}>
                  <Typography variant="body1">Customer Name</Typography>
                </Box>
                <Card
                  sx={{
                    border: "1px solid #e0e0e0",
                    background: "#f8f8f8bd",
                    borderRadius: 2,
                    p: 1,
                    pt: 0,
                    m: 0,
                    pb: 0,
                    boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                    transition: "box-shadow .2s",
                  }}
                >
                  <CardContent sx={{ p: 1 }}>
                    <Box className={formGroup}>
                      <Typography variant="body2">
                        Aadhaar: {panDetails?.customer_name ?? "NA"}
                      </Typography>
                    </Box>
                    <Box className={formGroup}>
                      <Typography variant="body2">
                        PAN: {panDetails?.name_in_pan ?? "NA"}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
              <Box mt={2}>
                <Box className={formGroup}>
                  <Typography variant="body1">Customer DOB</Typography>
                </Box>
                <Card
                  sx={{
                    border: "1px solid #e0e0e0",
                    background: "#f8f8f8bd",
                    borderRadius: 2,
                    p: 1,
                    pt: 0,
                    m: 0,
                    pb: 0,
                    boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                    transition: "box-shadow .2s",
                  }}
                >
                  <CardContent sx={{ p: 1 }}>
                    <Box className={formGroup}>
                      <Typography variant="body2">
                        Aadhaar: {panDetails?.customer_dob ?? "NA"}
                      </Typography>
                    </Box>
                    <Box className={formGroup}>
                      <Typography variant="body2">
                        PAN: {panDetails?.dob_in_pan ?? "NA"}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
              <Box mt={2}>
                <Box className={formGroup}>
                  <Typography variant="body1">Remark</Typography>
                </Box>
                <Card
                  sx={{
                    border: "1px solid #e0e0e0",
                    background: "#f8f8f8bd",
                    borderRadius: 2,
                    p: 1,
                    pt: 0,
                    m: 0,
                    pb: 0,
                    boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                    transition: "box-shadow .2s",
                  }}
                >
                  <CardContent sx={{ p: 1 }}>
                    <Typography variant="body2">
                      Since <strong>partial match found</strong>, this may need
                      to an <strong>RTS</strong>.
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Box>
            <Box className={containerButton}>
              <Box mt={1}>
                <CallToAction
                  buttonType={"click"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={false}
                  isFormSubmitted={isFormSubmitted}
                  text={"CLOSE"}
                  handleClick={() => handleClose("panMismatch", false)}
                />
              </Box>
            </Box>
          </Box>
        </Dialog>
      )}

      <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          sx={{ width: "100%" }}
          textAlign="center"
        >
          <Typography variant="body1">
            Processing request, please wait.
          </Typography>
          <Box mt={2}>
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      </Backdrop>
    </form>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerDetailsForm);
